<a class="toggleUi" (click)="toggleUi()">
  <span [ngClass]="!isCollapsed ? 'collapseIcon' : 'expandIcon'"></span>
  @if (!isCollapsed) {
    <span class="label">Hide ASM</span>
  } @else {
    <span class="label">Show ASM</span>
  }
</a>
